// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__xTXGa","location":"Header_location__3mNPq"};